var module = angular.module('octopusApp.library');

module.controller('ScriptModulesIndexController', function($scope, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  isLoading.promise(octopusRepository.LibraryVariableSets.list({contentType: 'ScriptModule'}).then(function (scriptModules) {
    $scope.scriptModules = scriptModules;
  }));
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/scripts/controllers/script_modules_index_controller.js
// module id = 5171137924794480
// module chunks = 1